import { ensureAuthenticated } from '@lune/auth/ensure'
import { ErrorPage } from '@lune/common/errors'
import { printRouterTree } from '@lune/common/router'
import React from 'react'
import { Navigate, RouterProvider, createBrowserRouter } from 'react-router-dom'
import { version } from './api/version'
import { Dashboard } from './components/dashboard'
import {
  DefaultPage,
  LegacyFancyLoginPage,
  LegacyLoginFailed,
  LegacyLoginSuccess,
  LoginFailedPage,
  LoginPage,
  LoginSuccessPage,
  MediasRoute,
  Root,
  SearchRoute
} from './paths'

const MediasPage = React.lazy(
  async () =>
    await import('./pages/medias').then((module) => ({
      default: module.MediasPage
    }))
)
const SearchPage = React.lazy(
  async () =>
    await import('./pages/search').then((module) => ({
      default: module.SearchPage
    }))
)
const PageLogin = React.lazy(
  async () =>
    await import('./pages/login').then((module) => ({
      default: module.LoginPage
    }))
)
const PageTest = React.lazy(
  async () =>
    await import('./pages/test').then((module) => ({
      default: module.TestPage
    }))
)

const loginWithoutQueryOrHash = (): string => {
  const url: string = LoginSuccessPage.login.success.url.toString()
  return url.replace(/\?.*$/, '').replace(/#.*$/, '')
}

const routerPaths = [
  {
    path: loginWithoutQueryOrHash(),
    element: <Navigate to={DefaultPage('')} replace={true} />,
    errorElement: <ErrorPage />
  },
  {
    path: LoginPage.login.url.toString(),
    element: <PageLogin />,
    errorElement: <ErrorPage />
  },
  {
    path: LegacyFancyLoginPage,
    element: <Navigate to={LoginPage.login.url.toString()} replace={true} />,
    errorElement: <ErrorPage />
  },
  {
    path: LegacyLoginSuccess,
    element: (
      <Navigate
        to={LoginSuccessPage.login.success.url.toString()}
        replace={true}
      />
    ),
    errorElement: <ErrorPage />
  },
  {
    path: LegacyLoginFailed,
    element: (
      <Navigate
        to={LoginFailedPage.login.failed.url.toString()}
        replace={true}
      />
    ),
    errorElement: <ErrorPage />
  },
  {
    path: Root.root.url.toString(),
    element: <Dashboard />,
    loader: () => ensureAuthenticated(version, LoginPage, Root),
    errorElement: <ErrorPage />,
    children: [
      {
        path: Root.root.url.toString(),
        element: <Navigate to={DefaultPage('')} replace={true} />,
        errorElement: <ErrorPage />
      },
      {
        path: MediasRoute,
        element: <MediasPage />,
        errorElement: <ErrorPage />
      },
      {
        path: SearchRoute,
        element: <SearchPage />,
        errorElement: <ErrorPage />
      }
    ]
  },
  {
    path: '/test',
    element: <PageTest />
  }
]

printRouterTree(routerPaths)

const router = createBrowserRouter(routerPaths)

export const App: React.FC = () => <RouterProvider router={router} />
